export default "__VITE_ASSET__DaQm4I1w__"